import React, { useState, useEffect, useRef } from "react";
import {
  Wrapper,
  DropdownContainer,
  SelectedItem,
  DropdownIconWrapper,
} from "./index.sc";
import { ReactComponent as FilterDropdownIcon } from "../../Assets/Icons/FilterDropdownIcon.svg";
import { ReactComponent as InfoIcon } from "../../Assets/Icons/Info.svg";
import OptionsList from "../OptionsList"; // Import the new component
import Info from "../Info";
import { useSelector } from "react-redux";
import { useFilters } from "../../hooks/useFilters";
import { GLOBAL_FILTER_OPTIONS } from "../../Configs/filters.config";

const predefinedOptions = GLOBAL_FILTER_OPTIONS;

const CustomDropdown = ({
  setCustomFilterFlag,
  setFilteredData,
  onEditClick = () => {},
  selectedOption,
  setSelectedOption,
}) => {
  const { tableViewData } = useSelector((store) => store.app);
  const { setGlobalFilter } = useFilters();
  // const [selectedOption, setSelectedOption] = useState(globalFilter);
  const [isOpen, setIsOpen] = useState(false);
  const [options, setOptions] = useState(predefinedOptions); // Store combined options
  const dropdownRef = useRef(null);

  // Fetch search history from localStorage and merge with options
  useEffect(() => {
    const storedSearchHistory = localStorage.getItem("searchHistory");
    if (storedSearchHistory) {
      try {
        const parsedSearchHistory = JSON.parse(storedSearchHistory);
        const customSearchOptions = parsedSearchHistory.map((item) => ({
          value: item, // Store full object for filtering
          label: `${item.title}`,
          customSearch: true, // Flag to differentiate
        }));
        setOptions([...predefinedOptions, ...customSearchOptions]);
      } catch (error) {
        console.error("Error parsing search history:", error);
      }
    }
  }, [isOpen]);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (option) => {
    setSelectedOption(option);

    setIsOpen(false);

    if (option.customSearch) {
      if (tableViewData?.filterFlag) setGlobalFilter("all");
      setCustomFilterFlag(true);
      setFilteredData(option.value.filteredData);
    } else {
      setCustomFilterFlag(false);
      // Global + advanced filters now apply together. Keep any applied advanced
      // filters (form state, URL params, redux filterFlag) intact and only
      // update the globalFilter param. LeftSection refetches from the updated
      // URL, combining the global filter with the advanced filters.
      setGlobalFilter(option.value);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Wrapper ref={dropdownRef}>
      <DropdownContainer onClick={toggleDropdown}>
        <SelectedItem>
          {selectedOption.label}
          <Info
            showArrow={false}
            config={{
              tooltipText: "Options",
              position: "top",
            }}
          >
            <DropdownIconWrapper isOpen={isOpen}>
              <FilterDropdownIcon />
            </DropdownIconWrapper>
          </Info>
        </SelectedItem>
        <OptionsList
          options={options}
          onOptionClick={handleOptionClick}
          selectedOption={selectedOption.label}
          isOpen={isOpen}
          setOptions={setOptions}
          onEditClick={(option) => {
            setIsOpen(false);
            onEditClick(option);
          }}
        />
      </DropdownContainer>
    </Wrapper>
  );
};

export default CustomDropdown;
